import React from 'react';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Modal from '@components/common/Modals/Modal/Modal';
import Text from '@components/common/Text/Text';

import css from './DecriptionGenerationBlockedModal.module.scss';

type DescriptionGenerationBlockedModalProps = {
    isVisible: boolean;
    onHide: () => void;
};

const DescriptionGenerationBlockedModal = ({ isVisible, onHide }: DescriptionGenerationBlockedModalProps) => {
    const { t } = useTranslateLpc(['lpc-create-pot', 'common']);

    return (
        <Modal visible={isVisible} onHide={onHide} customClass={css.blocked_description_modal}>
            <div>
                <div className={css.header}>
                    <h5>{t('form.solidarity-pool.ai-editor.blocked-modal.title')}</h5>
                    <div>
                        <Text variant={'caption_01'} color={'txt-primary'}>
                            {t('form.solidarity-pool.ai-editor.blocked-modal.desc')}
                        </Text>
                    </div>
                </div>
                <div className={css.close_bloc}>
                    <Button
                        type={'button'}
                        customClass={css.close_bloc__cta}
                        variant={'secondary'}
                        onClick={() => {
                            onHide();
                        }}
                    >
                        {t('form.solidarity-pool.ai-editor.blocked-modal.close')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DescriptionGenerationBlockedModal;
